import React from 'react'
import { FontIcon, tokens } from '@arvoreeducacao/bonsai-ds'
import { BookCoverFooterMobile, EllipsisIcon } from './BookInfo.styles'
import type { BookInfoProps } from './BookInfo.types'

const BookInfoMobile = ({
  setIsOpen,
  moreActionsEvent
}: Pick<BookInfoProps, 'setIsOpen' | 'moreActionsEvent'>) => {
  return (
    <BookCoverFooterMobile>
      <EllipsisIcon
        data-testid="ellipsis-icon"
        onClick={e => {
          e.stopPropagation()
          moreActionsEvent && moreActionsEvent()
          setIsOpen(true)
        }}
      >
        <FontIcon
          iconName={'ellipsis-vertical'}
          color={tokens.colors.dark5}
          size={20}
        />
      </EllipsisIcon>
    </BookCoverFooterMobile>
  )
}

export default BookInfoMobile
